import { Link } from 'react-router'
import { LANDING } from '@/shell/landing'

/** PRD-018 §3.13: no existence leak; one plain line and a way back. */
export function NoAccessPage() {
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <h1 className="text-lg font-semibold text-primary">You do not have access to this page</h1>
      <p className="mt-2 text-sm text-tertiary">If you expected to, ask the file manager or a CFO to add you.</p>
      <Link to={LANDING} className="mt-6 inline-block text-sm font-medium text-brand-secondary">Go to Home</Link>
    </div>
  )
}
export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <h1 className="text-lg font-semibold text-primary">There is nothing at this address</h1>
      <p className="mt-2 text-sm text-tertiary">The link may be old or mistyped. The tree on the left still works.</p>
      <Link to={LANDING} className="mt-6 inline-block text-sm font-medium text-brand-secondary">Go to Home</Link>
    </div>
  )
}
